import {t} from 'i18next';
import {translations} from '../../i18n/translations';

// Make the first letter of a text string uppercase
export const titleCase = (text: string) => {
  if (!text || text.length === 0) return '';
  const textLowerCased = text.toLocaleLowerCase();
  return textLowerCased[0].toUpperCase() + textLowerCased.slice(1);
};

// Join mapped items as an expression
export const joinAsExpression = (items: string[] | undefined) => {
  if (!items || items.length === 0) return '-';
  return items
    .join(', ')
    .replace(/,(?=[^,]*$)/, ` ${t(translations.schedule_field.readable_periodicity.and)}`);
};
